<template>
  <a-modal
    class="table-list-modal"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    title="推广员列表"
    :footer="null"
    @cancel="$emit('onCancel')"
  >
    <a-table
      style="margin-bottom:50px;"
      :columns="columns"
      :data-source="data"
      size="middle"
      :row-key="record => record.promoter_id"
      :pagination="false"
    />
    <slot />
  </a-modal>
</template>
<script>
export default {
  props: ['data', 'visible' ],
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'promoter_id',
        },
        {
          title: '推广员名称',
          dataIndex: 'user_realname',
        },
		{
		  title: '分配任务数',
		  dataIndex: 'assigned_num',
		},
        {
          title: '推广员电话',
          dataIndex: 'mobile',
        },
        {
          title: '任务状态',
          dataIndex: 'task_status_name',
        },
      ],
    };
  },
  mounted() {

  },
  methods: {
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows){
      this.selectedRowKeys = selectedRowKeys;
    },

  },
};
</script>
<style lang="scss" >
.table-list-modal{

}
</style>